import styled from 'styled-components';
import { NEGATIVE_500, POSITIVE_500 } from '../../styles/colors';
import { IconFont } from '../../styles/font';

export type IconType = '\uebe6' | '\ue923';

export const ICON_TYPES = {
  SUCCESS: '\uebe6' as IconType,
  NEGATIVE: '\ue923' as IconType,
} as const;

const ICON_STYLES = `
  ${IconFont}
  font-family: 'rs-iconfont';
  font-weight: 700;
  font-style: normal;
`;

export const Icon = styled.i<{ type: IconType }>`
  &&& {
    :before {
      content: '${({ type }) => type}';
      color: ${({ type }) =>
        type === ICON_TYPES.SUCCESS ? POSITIVE_500 : NEGATIVE_500};
      ${ICON_STYLES}
    }
  }
`;
